module.exports = __webpack_public_path__ + "static/img/u78.1007a910.png";